module.exports = __webpack_public_path__ + "img/logo-mini.d264fe93.png";